import { render, staticRenderFns } from "./ConfigureDocumentReceipents.vue?vue&type=template&id=42311532"
import script from "./ConfigureDocumentReceipents.vue?vue&type=script&lang=js"
export * from "./ConfigureDocumentReceipents.vue?vue&type=script&lang=js"
import style0 from "./ConfigureDocumentReceipents.vue?vue&type=style&index=0&id=42311532&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports